webpackJsonp([241767136424496],{

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(78);
	
	var emptyObject = __webpack_require__(124);
	var _invariant = __webpack_require__(75);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(349);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 372:
/***/ (function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(50);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(49);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(94);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(93);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(185);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	!function(root, factory) {
	     true ? module.exports = factory() : "function" == typeof define && define.amd ? define([], factory) : "object" == typeof exports ? exports.ReactImageLightbox = factory() : root.ReactImageLightbox = factory();
	}("undefined" != typeof self ? self : this, function() {
	    /******/
	    return function(modules) {
	        /******/
	        /******/
	        // The require function
	        /******/
	        function __webpack_require__(moduleId) {
	            /******/
	            /******/
	            // Check if module is in cache
	            /******/
	            if (installedModules[moduleId]) /******/
	            return installedModules[moduleId].exports;
	            /******/
	            // Create a new module (and put it into the cache)
	            /******/
	            var module = installedModules[moduleId] = {
	                /******/
	                i: moduleId,
	                /******/
	                l: !1,
	                /******/
	                exports: {}
	            };
	            /******/
	            /******/
	            // Return the exports of the module
	            /******/
	            /******/
	            /******/
	            // Execute the module function
	            /******/
	            /******/
	            /******/
	            // Flag the module as loaded
	            /******/
	            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
	            module.l = !0, module.exports;
	        }
	        // webpackBootstrap
	        /******/
	        // The module cache
	        /******/
	        var installedModules = {};
	        /******/
	        /******/
	        // Load entry module and return exports
	        /******/
	        /******/
	        /******/
	        /******/
	        // expose the modules object (__webpack_modules__)
	        /******/
	        /******/
	        /******/
	        // expose the module cache
	        /******/
	        /******/
	        /******/
	        // define getter function for harmony exports
	        /******/
	        /******/
	        /******/
	        // getDefaultExport function for compatibility with non-harmony modules
	        /******/
	        /******/
	        /******/
	        // Object.prototype.hasOwnProperty.call
	        /******/
	        /******/
	        /******/
	        // __webpack_public_path__
	        /******/
	        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
	        __webpack_require__.d = function(exports, name, getter) {
	            /******/
	            __webpack_require__.o(exports, name) || /******/
	            Object.defineProperty(exports, name, {
	                /******/
	                configurable: !1,
	                /******/
	                enumerable: !0,
	                /******/
	                get: getter
	            });
	        }, __webpack_require__.n = function(module) {
	            /******/
	            var getter = module && module.__esModule ? /******/
	            function() {
	                return module.default;
	            } : /******/
	            function() {
	                return module;
	            };
	            /******/
	            /******/
	            return __webpack_require__.d(getter, "a", getter), getter;
	        }, __webpack_require__.o = function(object, property) {
	            return Object.prototype.hasOwnProperty.call(object, property);
	        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 1);
	    }([ /* 0 */
	    /***/
	    function(module, exports) {
	        var g;
	        // This works in non-strict mode
	        g = function() {
	            return this;
	        }();
	        try {
	            // This works if eval is allowed (see CSP)
	            g = g || Function("return this")() || (0, eval)("this");
	        } catch (e) {
	            // This works if the window reference is available
	            "object" == typeof window && (g = window);
	        }
	        // g can still be undefined, but nothing to do about it...
	        // We return undefined, instead of nothing here, so it's
	        // easier to handle this case. if(!global) { ...}
	        module.exports = g;
	    }, /* 1 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = __webpack_require__(2).default;
	    }, /* 2 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        /* WEBPACK VAR INJECTION */
	        (function(global) {
	            function _interopRequireDefault(obj) {
	                return obj && obj.__esModule ? obj : {
	                    default: obj
	                };
	            }
	            function _toConsumableArray(arr) {
	                if (Array.isArray(arr)) {
	                    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	                    return arr2;
	                }
	                return Array.from(arr);
	            }
	            function _defineProperty(obj, key, value) {
	                return key in obj ? Object.defineProperty(obj, key, {
	                    value: value,
	                    enumerable: !0,
	                    configurable: !0,
	                    writable: !0
	                }) : obj[key] = value, obj;
	            }
	            function _classCallCheck(instance, Constructor) {
	                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
	            }
	            function _possibleConstructorReturn(self, call) {
	                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	                return !call || "object" != typeof call && "function" != typeof call ? self : call;
	            }
	            function _inherits(subClass, superClass) {
	                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	                subClass.prototype = Object.create(superClass && superClass.prototype, {
	                    constructor: {
	                        value: subClass,
	                        enumerable: !1,
	                        writable: !0,
	                        configurable: !0
	                    }
	                }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	            }
	            Object.defineProperty(exports, "__esModule", {
	                value: !0
	            });
	            var _slicedToArray = function() {
	                function sliceIterator(arr, i) {
	                    var _arr = [], _n = !0, _d = !1, _e = void 0;
	                    try {
	                        for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
	                        !i || _arr.length !== i); _n = !0) ;
	                    } catch (err) {
	                        _d = !0, _e = err;
	                    } finally {
	                        try {
	                            !_n && _i.return && _i.return();
	                        } finally {
	                            if (_d) throw _e;
	                        }
	                    }
	                    return _arr;
	                }
	                return function(arr, i) {
	                    if (Array.isArray(arr)) return arr;
	                    if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
	                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	                };
	            }(), _createClass = function() {
	                function defineProperties(target, props) {
	                    for (var i = 0; i < props.length; i++) {
	                        var descriptor = props[i];
	                        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
	                        "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	                    }
	                }
	                return function(Constructor, protoProps, staticProps) {
	                    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
	                    Constructor;
	                };
	            }(), _extends = Object.assign || function(target) {
	                for (var i = 1; i < arguments.length; i++) {
	                    var source = arguments[i];
	                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	                }
	                return target;
	            }, _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(4), _propTypes2 = _interopRequireDefault(_propTypes), _reactModal = __webpack_require__(5), _reactModal2 = _interopRequireDefault(_reactModal), _util = __webpack_require__(6), _constant = __webpack_require__(7), _style = __webpack_require__(8), _style2 = _interopRequireDefault(_style), styles = _style2.default, ieVersion = (0, 
	            _util.getIEVersion)();
	            ieVersion < 10 && (styles = _extends({}, styles, {
	                toolbarSide: styles.toolbarSide + " " + styles.toolbarSideNoFlex,
	                toolbarLeftSide: styles.toolbarLeftSide + " " + styles.toolbarLeftSideNoFlex,
	                toolbarRightSide: styles.toolbarRightSide + " " + styles.toolbarRightSideNoFlex
	            }));
	            var ReactImageLightbox = function(_Component) {
	                function ReactImageLightbox(props) {
	                    _classCallCheck(this, ReactImageLightbox);
	                    var _this = _possibleConstructorReturn(this, (ReactImageLightbox.__proto__ || Object.getPrototypeOf(ReactImageLightbox)).call(this, props));
	                    return _this.state = {
	                        //-----------------------------
	                        // Animation
	                        //-----------------------------
	                        // Lightbox is closing
	                        // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
	                        isClosing: !props.animationDisabled,
	                        // Component parts should animate (e.g., when images are moving, or image is being zoomed)
	                        shouldAnimate: !1,
	                        //-----------------------------
	                        // Zoom settings
	                        //-----------------------------
	                        // Zoom level of image
	                        zoomLevel: _constant.MIN_ZOOM_LEVEL,
	                        //-----------------------------
	                        // Image position settings
	                        //-----------------------------
	                        // Horizontal offset from center
	                        offsetX: 0,
	                        // Vertical offset from center
	                        offsetY: 0,
	                        // image load error for srcType
	                        loadErrorStatus: {}
	                    }, _this.closeIfClickInner = _this.closeIfClickInner.bind(_this), _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_this), 
	                    _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_this), _this.handleKeyInput = _this.handleKeyInput.bind(_this), 
	                    _this.handleMouseUp = _this.handleMouseUp.bind(_this), _this.handleMouseDown = _this.handleMouseDown.bind(_this), 
	                    _this.handleMouseMove = _this.handleMouseMove.bind(_this), _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_this), 
	                    _this.handleTouchStart = _this.handleTouchStart.bind(_this), _this.handleTouchMove = _this.handleTouchMove.bind(_this), 
	                    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this), _this.handlePointerEvent = _this.handlePointerEvent.bind(_this), 
	                    _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_this), _this.handleWindowResize = _this.handleWindowResize.bind(_this), 
	                    _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_this), _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_this), 
	                    _this.requestClose = _this.requestClose.bind(_this), _this.requestMoveNext = _this.requestMoveNext.bind(_this), 
	                    _this.requestMovePrev = _this.requestMovePrev.bind(_this), _this;
	                }
	                return _inherits(ReactImageLightbox, _Component), _createClass(ReactImageLightbox, null, [ {
	                    key: "isTargetMatchImage",
	                    value: function(target) {
	                        return target && /ril-image-current/.test(target.className);
	                    }
	                }, {
	                    key: "parseMouseEvent",
	                    value: function(mouseEvent) {
	                        return {
	                            id: "mouse",
	                            source: _constant.SOURCE_MOUSE,
	                            x: parseInt(mouseEvent.clientX, 10),
	                            y: parseInt(mouseEvent.clientY, 10)
	                        };
	                    }
	                }, {
	                    key: "parseTouchPointer",
	                    value: function(touchPointer) {
	                        return {
	                            id: touchPointer.identifier,
	                            source: _constant.SOURCE_TOUCH,
	                            x: parseInt(touchPointer.clientX, 10),
	                            y: parseInt(touchPointer.clientY, 10)
	                        };
	                    }
	                }, {
	                    key: "parsePointerEvent",
	                    value: function(pointerEvent) {
	                        return {
	                            id: pointerEvent.pointerId,
	                            source: _constant.SOURCE_POINTER,
	                            x: parseInt(pointerEvent.clientX, 10),
	                            y: parseInt(pointerEvent.clientY, 10)
	                        };
	                    }
	                }, {
	                    key: "getTransform",
	                    value: function(_ref) {
	                        var _ref$x = _ref.x, x = void 0 === _ref$x ? 0 : _ref$x, _ref$y = _ref.y, y = void 0 === _ref$y ? 0 : _ref$y, _ref$zoom = _ref.zoom, zoom = void 0 === _ref$zoom ? 1 : _ref$zoom, width = _ref.width, targetWidth = _ref.targetWidth, nextX = x, isOldIE = ieVersion < 10, windowWidth = (0, 
	                        _util.getWindowWidth)();
	                        width > windowWidth && (nextX += (windowWidth - width) / 2);
	                        var scaleFactor = zoom * (targetWidth / width);
	                        return isOldIE ? {
	                            msTransform: "translate(" + nextX + "px," + y + "px) scale(" + scaleFactor + ")"
	                        } : {
	                            transform: "translate3d(" + nextX + "px," + y + "px,0) scale3d(" + scaleFactor + "," + scaleFactor + ",1)"
	                        };
	                    }
	                }, {
	                    key: "loadStyles",
	                    value: function() {
	                        // Insert component styles
	                        void 0 !== global.window && // eslint-disable-next-line no-underscore-dangle
	                        styles._insertCss();
	                    }
	                } ]), _createClass(ReactImageLightbox, [ {
	                    key: "componentWillMount",
	                    value: function() {
	                        // Timeouts - always clear it before umount
	                        this.timeouts = [], // Current action
	                        this.currentAction = _constant.ACTION_NONE, // Events source
	                        this.eventsSource = _constant.SOURCE_ANY, // Empty pointers list
	                        this.pointerList = [], // Prevent inner close
	                        this.preventInnerClose = !1, this.preventInnerCloseTimeout = null, // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
	                        this.keyPressed = !1, // Used to store load state / dimensions of images
	                        this.imageCache = {}, // Time the last keydown event was called (used in keyboard action rate limiting)
	                        this.lastKeyDownTime = 0, // Used for debouncing window resize event
	                        this.resizeTimeout = null, // Used to determine when actions are triggered by the scroll wheel
	                        this.wheelActionTimeout = null, this.resetScrollTimeout = null, this.scrollX = 0, 
	                        this.scrollY = 0, // Used in panning zoomed images
	                        this.moveStartX = 0, this.moveStartY = 0, this.moveStartOffsetX = 0, this.moveStartOffsetY = 0, 
	                        // Used to swipe
	                        this.swipeStartX = 0, this.swipeStartY = 0, this.swipeEndX = 0, this.swipeEndY = 0, 
	                        // Used to pinch
	                        this.pinchTouchList = null, this.pinchDistance = 0, // Used to differentiate between images with identical src
	                        this.keyCounter = 0, // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
	                        this.moveRequested = !1, this.props.animationDisabled || // Make opening animation play
	                        this.setState({
	                            isClosing: !1
	                        });
	                    }
	                }, {
	                    key: "componentDidMount",
	                    value: function() {
	                        var _this2 = this;
	                        ReactImageLightbox.loadStyles(), // Prevents cross-origin errors when using a cross-origin iframe
	                        this.windowContext = (0, _util.getHighestSafeWindowContext)(), this.listeners = {
	                            resize: this.handleWindowResize,
	                            mouseup: this.handleMouseUp,
	                            touchend: this.handleTouchEnd,
	                            touchcancel: this.handleTouchEnd,
	                            pointerdown: this.handlePointerEvent,
	                            pointermove: this.handlePointerEvent,
	                            pointerup: this.handlePointerEvent,
	                            pointercancel: this.handlePointerEvent
	                        }, Object.keys(this.listeners).forEach(function(type) {
	                            _this2.windowContext.addEventListener(type, _this2.listeners[type]);
	                        }), this.loadAllImages();
	                    }
	                }, {
	                    key: "componentWillReceiveProps",
	                    value: function(nextProps) {
	                        var _this3 = this, sourcesChanged = !1, prevSrcDict = {}, nextSrcDict = {};
	                        this.getSrcTypes().forEach(function(srcType) {
	                            _this3.props[srcType.name] !== nextProps[srcType.name] && (sourcesChanged = !0, 
	                            prevSrcDict[_this3.props[srcType.name]] = !0, nextSrcDict[nextProps[srcType.name]] = !0);
	                        }), (sourcesChanged || this.moveRequested) && (// Reset the loaded state for images not rendered next
	                        Object.keys(prevSrcDict).forEach(function(prevSrc) {
	                            !(prevSrc in nextSrcDict) && prevSrc in _this3.imageCache && (_this3.imageCache[prevSrc].loaded = !1);
	                        }), this.moveRequested = !1, // Load any new images
	                        this.loadAllImages(nextProps));
	                    }
	                }, {
	                    key: "shouldComponentUpdate",
	                    value: function() {
	                        // Wait for move...
	                        return !this.moveRequested;
	                    }
	                }, {
	                    key: "componentWillUnmount",
	                    value: function() {
	                        var _this4 = this;
	                        this.didUnmount = !0, Object.keys(this.listeners).forEach(function(type) {
	                            _this4.windowContext.removeEventListener(type, _this4.listeners[type]);
	                        }), this.timeouts.forEach(function(tid) {
	                            return clearTimeout(tid);
	                        });
	                    }
	                }, {
	                    key: "setTimeout",
	                    value: function(_setTimeout) {
	                        function setTimeout(_x, _x2) {
	                            return _setTimeout.apply(this, arguments);
	                        }
	                        return setTimeout.toString = function() {
	                            return _setTimeout.toString();
	                        }, setTimeout;
	                    }(function(func, time) {
	                        var _this5 = this, id = setTimeout(function() {
	                            _this5.timeouts = _this5.timeouts.filter(function(tid) {
	                                return tid !== id;
	                            }), func();
	                        }, time);
	                        return this.timeouts.push(id), id;
	                    })
	                }, {
	                    key: "setPreventInnerClose",
	                    value: function() {
	                        var _this6 = this;
	                        this.preventInnerCloseTimeout && this.clearTimeout(this.preventInnerCloseTimeout), 
	                        this.preventInnerClose = !0, this.preventInnerCloseTimeout = this.setTimeout(function() {
	                            _this6.preventInnerClose = !1, _this6.preventInnerCloseTimeout = null;
	                        }, 100);
	                    }
	                }, {
	                    key: "getBestImageForType",
	                    value: function(srcType) {
	                        var imageSrc = this.props[srcType], fitSizes = {};
	                        if (this.isImageLoaded(imageSrc)) // Use full-size image if available
	                        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height); else {
	                            if (!this.isImageLoaded(this.props[srcType + "Thumbnail"])) return null;
	                            // Fall back to using thumbnail if the image has not been loaded
	                            imageSrc = this.props[srcType + "Thumbnail"], fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, !0);
	                        }
	                        return {
	                            src: imageSrc,
	                            height: this.imageCache[imageSrc].height,
	                            width: this.imageCache[imageSrc].width,
	                            targetHeight: fitSizes.height,
	                            targetWidth: fitSizes.width
	                        };
	                    }
	                }, {
	                    key: "getFitSizes",
	                    value: function(width, height, stretch) {
	                        var boxSize = this.getLightboxRect(), maxHeight = boxSize.height - 2 * this.props.imagePadding, maxWidth = boxSize.width - 2 * this.props.imagePadding;
	                        return stretch || (maxHeight = Math.min(maxHeight, height), maxWidth = Math.min(maxWidth, width)), 
	                        maxWidth / maxHeight > width / height ? {
	                            width: width * maxHeight / height,
	                            height: maxHeight
	                        } : {
	                            width: maxWidth,
	                            height: height * maxWidth / width
	                        };
	                    }
	                }, {
	                    key: "getMaxOffsets",
	                    value: function() {
	                        var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel, currentImageInfo = this.getBestImageForType("mainSrc");
	                        if (null === currentImageInfo) return {
	                            maxX: 0,
	                            minX: 0,
	                            maxY: 0,
	                            minY: 0
	                        };
	                        var boxSize = this.getLightboxRect(), zoomMultiplier = this.getZoomMultiplier(zoomLevel), maxX = 0;
	                        // if there is still blank space in the X dimension, don't limit except to the opposite edge
	                        maxX = zoomMultiplier * currentImageInfo.width - boxSize.width < 0 ? (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2 : (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
	                        var maxY = 0;
	                        // if there is still blank space in the Y dimension, don't limit except to the opposite edge
	                        return maxY = zoomMultiplier * currentImageInfo.height - boxSize.height < 0 ? (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2 : (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2, 
	                        {
	                            maxX: maxX,
	                            maxY: maxY,
	                            minX: -1 * maxX,
	                            minY: -1 * maxY
	                        };
	                    }
	                }, {
	                    key: "getSrcTypes",
	                    value: function() {
	                        return [ {
	                            name: "mainSrc",
	                            keyEnding: "i" + this.keyCounter
	                        }, {
	                            name: "mainSrcThumbnail",
	                            keyEnding: "t" + this.keyCounter
	                        }, {
	                            name: "nextSrc",
	                            keyEnding: "i" + (this.keyCounter + 1)
	                        }, {
	                            name: "nextSrcThumbnail",
	                            keyEnding: "t" + (this.keyCounter + 1)
	                        }, {
	                            name: "prevSrc",
	                            keyEnding: "i" + (this.keyCounter - 1)
	                        }, {
	                            name: "prevSrcThumbnail",
	                            keyEnding: "t" + (this.keyCounter - 1)
	                        } ];
	                    }
	                }, {
	                    key: "getZoomMultiplier",
	                    value: function() {
	                        var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel;
	                        return Math.pow(_constant.ZOOM_RATIO, zoomLevel);
	                    }
	                }, {
	                    key: "getLightboxRect",
	                    value: function() {
	                        return this.outerEl ? this.outerEl.getBoundingClientRect() : {
	                            width: (0, _util.getWindowWidth)(),
	                            height: (0, _util.getWindowHeight)(),
	                            top: 0,
	                            right: 0,
	                            bottom: 0,
	                            left: 0
	                        };
	                    }
	                }, {
	                    key: "clearTimeout",
	                    value: function(_clearTimeout) {
	                        function clearTimeout(_x3) {
	                            return _clearTimeout.apply(this, arguments);
	                        }
	                        return clearTimeout.toString = function() {
	                            return _clearTimeout.toString();
	                        }, clearTimeout;
	                    }(function(id) {
	                        this.timeouts = this.timeouts.filter(function(tid) {
	                            return tid !== id;
	                        }), clearTimeout(id);
	                    })
	                }, {
	                    key: "changeZoom",
	                    value: function(zoomLevel, clientX, clientY) {
	                        // Ignore if zoom disabled
	                        if (this.props.enableZoom) {
	                            // Constrain zoom level to the set bounds
	                            var nextZoomLevel = Math.max(_constant.MIN_ZOOM_LEVEL, Math.min(_constant.MAX_ZOOM_LEVEL, zoomLevel));
	                            // Ignore requests that don't change the zoom level
	                            if (nextZoomLevel !== this.state.zoomLevel) {
	                                if (nextZoomLevel === _constant.MIN_ZOOM_LEVEL) // Snap back to center if zoomed all the way out
	                                return void this.setState({
	                                    zoomLevel: nextZoomLevel,
	                                    offsetX: 0,
	                                    offsetY: 0
	                                });
	                                var imageBaseSize = this.getBestImageForType("mainSrc");
	                                if (null !== imageBaseSize) {
	                                    var currentZoomMultiplier = this.getZoomMultiplier(), nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel), boxRect = this.getLightboxRect(), pointerX = void 0 !== clientX ? clientX - boxRect.left : boxRect.width / 2, pointerY = void 0 !== clientY ? clientY - boxRect.top : boxRect.height / 2, currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2, currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2, currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX, currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY, currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier, currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier, nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier, nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier, nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2, nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2, nextOffsetX = nextImageOffsetX - nextImageRealOffsetX, nextOffsetY = nextImageOffsetY - nextImageRealOffsetY;
	                                    // When zooming out, limit the offset so things don't get left askew
	                                    if (this.currentAction !== _constant.ACTION_PINCH) {
	                                        var maxOffsets = this.getMaxOffsets();
	                                        this.state.zoomLevel > nextZoomLevel && (nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX)), 
	                                        nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY)));
	                                    }
	                                    this.setState({
	                                        zoomLevel: nextZoomLevel,
	                                        offsetX: nextOffsetX,
	                                        offsetY: nextOffsetY
	                                    });
	                                }
	                            }
	                        }
	                    }
	                }, {
	                    key: "closeIfClickInner",
	                    value: function(event) {
	                        !this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1 && this.requestClose(event);
	                    }
	                }, {
	                    key: "handleKeyInput",
	                    value: function(event) {
	                        // Ignore key input during animations
	                        if (event.stopPropagation(), !this.isAnimating()) {
	                            // Allow slightly faster navigation through the images when user presses keys repeatedly
	                            if ("keyup" === event.type) return void (this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus);
	                            var keyCode = event.which || event.keyCode, currentTime = new Date();
	                            if (!(currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== _constant.KEYS.ESC)) switch (this.lastKeyDownTime = currentTime.getTime(), 
	                            keyCode) {
	                              // ESC key closes the lightbox
	                                case _constant.KEYS.ESC:
	                                event.preventDefault(), this.requestClose(event);
	                                break;
	
	                              // Left arrow key moves to previous image
	                                case _constant.KEYS.LEFT_ARROW:
	                                if (!this.props.prevSrc) return;
	                                event.preventDefault(), this.keyPressed = !0, this.requestMovePrev(event);
	                                break;
	
	                              // Right arrow key moves to next image
	                                case _constant.KEYS.RIGHT_ARROW:
	                                if (!this.props.nextSrc) return;
	                                event.preventDefault(), this.keyPressed = !0, this.requestMoveNext(event);
	                            }
	                        }
	                    }
	                }, {
	                    key: "handleOuterMousewheel",
	                    value: function(event) {
	                        var _this7 = this;
	                        // Prevent scrolling of the background
	                        event.preventDefault(), event.stopPropagation();
	                        var xThreshold = _constant.WHEEL_MOVE_X_THRESHOLD, actionDelay = 0;
	                        // Prevent rapid-fire zoom behavior
	                        if (this.clearTimeout(this.resetScrollTimeout), this.resetScrollTimeout = this.setTimeout(function() {
	                            _this7.scrollX = 0, _this7.scrollY = 0;
	                        }, 300), null === this.wheelActionTimeout && !this.isAnimating()) {
	                            if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
	                                // handle horizontal scrolls with image moves
	                                this.scrollY = 0, this.scrollX += event.deltaX;
	                                var bigLeapX = xThreshold / 2;
	                                // If the scroll amount has accumulated sufficiently, or a large leap was taken
	                                this.scrollX >= xThreshold || event.deltaX >= bigLeapX ? (// Scroll right moves to next
	                                this.requestMoveNext(event), actionDelay = 500, this.scrollX = 0) : (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) && (// Scroll left moves to previous
	                                this.requestMovePrev(event), actionDelay = 500, this.scrollX = 0);
	                            }
	                            // Allow successive actions after the set delay
	                            0 !== actionDelay && (this.wheelActionTimeout = this.setTimeout(function() {
	                                _this7.wheelActionTimeout = null;
	                            }, actionDelay));
	                        }
	                    }
	                }, {
	                    key: "handleImageMouseWheel",
	                    value: function(event) {
	                        event.preventDefault();
	                        var yThreshold = _constant.WHEEL_MOVE_Y_THRESHOLD;
	                        if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
	                            // If the vertical scroll amount was large enough, perform a zoom
	                            if (event.stopPropagation(), Math.abs(event.deltaY) < yThreshold) return;
	                            this.scrollX = 0, this.scrollY += event.deltaY, this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
	                        }
	                    }
	                }, {
	                    key: "handleImageDoubleClick",
	                    value: function(event) {
	                        this.state.zoomLevel > _constant.MIN_ZOOM_LEVEL ? // A double click when zoomed in zooms all the way out
	                        this.changeZoom(_constant.MIN_ZOOM_LEVEL, event.clientX, event.clientY) : // A double click when zoomed all the way out zooms in
	                        this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
	                    }
	                }, {
	                    key: "shouldHandleEvent",
	                    value: function(source) {
	                        if (this.eventsSource === source) return !0;
	                        if (this.eventsSource === _constant.SOURCE_ANY) return this.eventsSource = source, 
	                        !0;
	                        switch (source) {
	                          case _constant.SOURCE_MOUSE:
	                            return !1;
	
	                          case _constant.SOURCE_TOUCH:
	                            return this.eventsSource = _constant.SOURCE_TOUCH, this.filterPointersBySource(), 
	                            !0;
	
	                          case _constant.SOURCE_POINTER:
	                            return this.eventsSource === _constant.SOURCE_MOUSE && (this.eventsSource = _constant.SOURCE_POINTER, 
	                            this.filterPointersBySource(), !0);
	
	                          default:
	                            return !1;
	                        }
	                    }
	                }, {
	                    key: "addPointer",
	                    value: function(pointer) {
	                        this.pointerList.push(pointer);
	                    }
	                }, {
	                    key: "removePointer",
	                    value: function(pointer) {
	                        this.pointerList = this.pointerList.filter(function(_ref2) {
	                            return _ref2.id !== pointer.id;
	                        });
	                    }
	                }, {
	                    key: "filterPointersBySource",
	                    value: function() {
	                        var _this8 = this;
	                        this.pointerList = this.pointerList.filter(function(_ref3) {
	                            return _ref3.source === _this8.eventsSource;
	                        });
	                    }
	                }, {
	                    key: "handleMouseDown",
	                    value: function(event) {
	                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parseMouseEvent(event)), 
	                        this.multiPointerStart(event));
	                    }
	                }, {
	                    key: "handleMouseMove",
	                    value: function(event) {
	                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && this.multiPointerMove(event, [ ReactImageLightbox.parseMouseEvent(event) ]);
	                    }
	                }, {
	                    key: "handleMouseUp",
	                    value: function(event) {
	                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && (this.removePointer(ReactImageLightbox.parseMouseEvent(event)), 
	                        this.multiPointerEnd(event));
	                    }
	                }, {
	                    key: "handlePointerEvent",
	                    value: function(event) {
	                        if (this.shouldHandleEvent(_constant.SOURCE_POINTER)) switch (event.type) {
	                          case "pointerdown":
	                            ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parsePointerEvent(event)), 
	                            this.multiPointerStart(event));
	                            break;
	
	                          case "pointermove":
	                            this.multiPointerMove(event, [ ReactImageLightbox.parsePointerEvent(event) ]);
	                            break;
	
	                          case "pointerup":
	                          case "pointercancel":
	                            this.removePointer(ReactImageLightbox.parsePointerEvent(event)), this.multiPointerEnd(event);
	                        }
	                    }
	                }, {
	                    key: "handleTouchStart",
	                    value: function(event) {
	                        var _this9 = this;
	                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target) && ([].forEach.call(event.changedTouches, function(eventTouch) {
	                            return _this9.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
	                        }), this.multiPointerStart(event));
	                    }
	                }, {
	                    key: "handleTouchMove",
	                    value: function(event) {
	                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && this.multiPointerMove(event, [].map.call(event.changedTouches, function(eventTouch) {
	                            return ReactImageLightbox.parseTouchPointer(eventTouch);
	                        }));
	                    }
	                }, {
	                    key: "handleTouchEnd",
	                    value: function(event) {
	                        var _this10 = this;
	                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ([].map.call(event.changedTouches, function(touch) {
	                            return _this10.removePointer(ReactImageLightbox.parseTouchPointer(touch));
	                        }), this.multiPointerEnd(event));
	                    }
	                }, {
	                    key: "decideMoveOrSwipe",
	                    value: function(pointer) {
	                        this.state.zoomLevel <= _constant.MIN_ZOOM_LEVEL ? this.handleSwipeStart(pointer) : this.handleMoveStart(pointer);
	                    }
	                }, {
	                    key: "multiPointerStart",
	                    value: function(event) {
	                        switch (this.handleEnd(null), this.pointerList.length) {
	                          case 1:
	                            event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
	                            break;
	
	                          case 2:
	                            event.preventDefault(), this.handlePinchStart(this.pointerList);
	                        }
	                    }
	                }, {
	                    key: "multiPointerMove",
	                    value: function(event, pointerList) {
	                        switch (this.currentAction) {
	                          case _constant.ACTION_MOVE:
	                            event.preventDefault(), this.handleMove(pointerList[0]);
	                            break;
	
	                          case _constant.ACTION_SWIPE:
	                            event.preventDefault(), this.handleSwipe(pointerList[0]);
	                            break;
	
	                          case _constant.ACTION_PINCH:
	                            event.preventDefault(), this.handlePinch(pointerList);
	                        }
	                    }
	                }, {
	                    key: "multiPointerEnd",
	                    value: function(event) {
	                        switch (this.currentAction !== _constant.ACTION_NONE && (this.setPreventInnerClose(), 
	                        this.handleEnd(event)), this.pointerList.length) {
	                          case 0:
	                            this.eventsSource = _constant.SOURCE_ANY;
	                            break;
	
	                          case 1:
	                            event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
	                            break;
	
	                          case 2:
	                            event.preventDefault(), this.handlePinchStart(this.pointerList);
	                        }
	                    }
	                }, {
	                    key: "handleEnd",
	                    value: function(event) {
	                        switch (this.currentAction) {
	                          case _constant.ACTION_MOVE:
	                            this.handleMoveEnd(event);
	                            break;
	
	                          case _constant.ACTION_SWIPE:
	                            this.handleSwipeEnd(event);
	                            break;
	
	                          case _constant.ACTION_PINCH:
	                            this.handlePinchEnd(event);
	                        }
	                    }
	                }, {
	                    key: "handleMoveStart",
	                    value: function(_ref4) {
	                        var clientX = _ref4.x, clientY = _ref4.y;
	                        this.props.enableZoom && (this.currentAction = _constant.ACTION_MOVE, this.moveStartX = clientX, 
	                        this.moveStartY = clientY, this.moveStartOffsetX = this.state.offsetX, this.moveStartOffsetY = this.state.offsetY);
	                    }
	                }, {
	                    key: "handleMove",
	                    value: function(_ref5) {
	                        var clientX = _ref5.x, clientY = _ref5.y, newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX, newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
	                        this.state.offsetX === newOffsetX && this.state.offsetY === newOffsetY || this.setState({
	                            offsetX: newOffsetX,
	                            offsetY: newOffsetY
	                        });
	                    }
	                }, {
	                    key: "handleMoveEnd",
	                    value: function() {
	                        var _this11 = this;
	                        this.currentAction = _constant.ACTION_NONE, this.moveStartX = 0, this.moveStartY = 0, 
	                        this.moveStartOffsetX = 0, this.moveStartOffsetY = 0;
	                        // Snap image back into frame if outside max offset range
	                        var maxOffsets = this.getMaxOffsets(), nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX)), nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
	                        nextOffsetX === this.state.offsetX && nextOffsetY === this.state.offsetY || (this.setState({
	                            offsetX: nextOffsetX,
	                            offsetY: nextOffsetY,
	                            shouldAnimate: !0
	                        }), this.setTimeout(function() {
	                            _this11.setState({
	                                shouldAnimate: !1
	                            });
	                        }, this.props.animationDuration));
	                    }
	                }, {
	                    key: "handleSwipeStart",
	                    value: function(_ref6) {
	                        var clientX = _ref6.x, clientY = _ref6.y;
	                        this.currentAction = _constant.ACTION_SWIPE, this.swipeStartX = clientX, this.swipeStartY = clientY, 
	                        this.swipeEndX = clientX, this.swipeEndY = clientY;
	                    }
	                }, {
	                    key: "handleSwipe",
	                    value: function(_ref7) {
	                        var clientX = _ref7.x, clientY = _ref7.y;
	                        this.swipeEndX = clientX, this.swipeEndY = clientY;
	                    }
	                }, {
	                    key: "handleSwipeEnd",
	                    value: function(event) {
	                        var xDiff = this.swipeEndX - this.swipeStartX, xDiffAbs = Math.abs(xDiff), yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
	                        if (this.currentAction = _constant.ACTION_NONE, this.swipeStartX = 0, this.swipeStartY = 0, 
	                        this.swipeEndX = 0, this.swipeEndY = 0, !(!event || this.isAnimating() || xDiffAbs < 1.5 * yDiffAbs)) {
	                            if (xDiffAbs < _constant.MIN_SWIPE_DISTANCE) {
	                                if (xDiffAbs < this.getLightboxRect().width / 4) return;
	                            }
	                            xDiff > 0 && this.props.prevSrc ? (event.preventDefault(), this.requestMovePrev()) : xDiff < 0 && this.props.nextSrc && (event.preventDefault(), 
	                            this.requestMoveNext());
	                        }
	                    }
	                }, {
	                    key: "calculatePinchDistance",
	                    value: function() {
	                        var _ref8 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref9 = _slicedToArray(_ref8, 2), a = _ref9[0], b = _ref9[1];
	                        return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
	                    }
	                }, {
	                    key: "calculatePinchCenter",
	                    value: function() {
	                        var _ref10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref11 = _slicedToArray(_ref10, 2), a = _ref11[0], b = _ref11[1];
	                        return {
	                            x: a.x - (a.x - b.x) / 2,
	                            y: a.y - (a.y - b.y) / 2
	                        };
	                    }
	                }, {
	                    key: "handlePinchStart",
	                    value: function(pointerList) {
	                        this.props.enableZoom && (this.currentAction = _constant.ACTION_PINCH, this.pinchTouchList = pointerList.map(function(_ref12) {
	                            return {
	                                id: _ref12.id,
	                                x: _ref12.x,
	                                y: _ref12.y
	                            };
	                        }), this.pinchDistance = this.calculatePinchDistance());
	                    }
	                }, {
	                    key: "handlePinch",
	                    value: function(pointerList) {
	                        this.pinchTouchList = this.pinchTouchList.map(function(oldPointer) {
	                            for (var i = 0; i < pointerList.length; i += 1) if (pointerList[i].id === oldPointer.id) return pointerList[i];
	                            return oldPointer;
	                        });
	                        var newDistance = this.calculatePinchDistance(), zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
	                        this.pinchDistance = newDistance;
	                        var _calculatePinchCenter = this.calculatePinchCenter(this.pinchTouchList), clientX = _calculatePinchCenter.x, clientY = _calculatePinchCenter.y;
	                        this.changeZoom(zoomLevel, clientX, clientY);
	                    }
	                }, {
	                    key: "handlePinchEnd",
	                    value: function() {
	                        this.currentAction = _constant.ACTION_NONE, this.pinchTouchList = null, this.pinchDistance = 0;
	                    }
	                }, {
	                    key: "handleWindowResize",
	                    value: function() {
	                        this.clearTimeout(this.resizeTimeout), this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
	                    }
	                }, {
	                    key: "handleZoomInButtonClick",
	                    value: function() {
	                        this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE);
	                    }
	                }, {
	                    key: "handleZoomOutButtonClick",
	                    value: function() {
	                        this.changeZoom(this.state.zoomLevel - _constant.ZOOM_BUTTON_INCREMENT_SIZE);
	                    }
	                }, {
	                    key: "handleCaptionMousewheel",
	                    value: function(event) {
	                        if (event.stopPropagation(), this.caption) {
	                            var _caption$getBoundingC = this.caption.getBoundingClientRect(), height = _caption$getBoundingC.height, _caption = this.caption, scrollHeight = _caption.scrollHeight, scrollTop = _caption.scrollTop;
	                            (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) && event.preventDefault();
	                        }
	                    }
	                }, {
	                    key: "isAnimating",
	                    value: function() {
	                        return this.state.shouldAnimate || this.state.isClosing;
	                    }
	                }, {
	                    key: "isImageLoaded",
	                    value: function(imageSrc) {
	                        return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
	                    }
	                }, {
	                    key: "loadImage",
	                    value: function(srcType, imageSrc, done) {
	                        var _this12 = this;
	                        // Return the image info if it is already cached
	                        if (this.isImageLoaded(imageSrc)) return void this.setTimeout(function() {
	                            done();
	                        }, 1);
	                        var inMemoryImage = new global.Image();
	                        this.props.imageCrossOrigin && (inMemoryImage.crossOrigin = this.props.imageCrossOrigin), 
	                        inMemoryImage.onerror = function(errorEvent) {
	                            _this12.props.onImageLoadError(imageSrc, srcType, errorEvent), // failed to load so set the state loadErrorStatus
	                            _this12.setState(function(prevState) {
	                                return {
	                                    loadErrorStatus: _extends({}, prevState.loadErrorStatus, _defineProperty({}, srcType, !0))
	                                };
	                            }), done(errorEvent);
	                        }, inMemoryImage.onload = function() {
	                            _this12.props.onImageLoad(imageSrc, srcType, inMemoryImage), _this12.imageCache[imageSrc] = {
	                                loaded: !0,
	                                width: inMemoryImage.width,
	                                height: inMemoryImage.height
	                            }, done();
	                        }, inMemoryImage.src = imageSrc;
	                    }
	                }, {
	                    key: "loadAllImages",
	                    value: function() {
	                        var _this13 = this, props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props, generateLoadDoneCallback = function(srcType, imageSrc) {
	                            return function(err) {
	                                // Give up showing image on error
	                                err || _this13.props[srcType] !== imageSrc || _this13.didUnmount || // Force rerender with the new image
	                                _this13.forceUpdate();
	                            };
	                        };
	                        // Load the images
	                        this.getSrcTypes().forEach(function(srcType) {
	                            var type = srcType.name;
	                            // there is no error when we try to load it initially
	                            props[type] && _this13.state.loadErrorStatus[type] && _this13.setState(function(prevState) {
	                                return {
	                                    loadErrorStatus: _extends({}, prevState.loadErrorStatus, _defineProperty({}, type, !1))
	                                };
	                            }), // Load unloaded images
	                            props[type] && !_this13.isImageLoaded(props[type]) && _this13.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
	                        });
	                    }
	                }, {
	                    key: "requestClose",
	                    value: function(event) {
	                        var _this14 = this, closeLightbox = function() {
	                            return _this14.props.onCloseRequest(event);
	                        };
	                        if (this.props.animationDisabled || "keydown" === event.type && !this.props.animationOnKeyInput) // No animation
	                        return void closeLightbox();
	                        // With animation
	                        // Start closing animation
	                        this.setState({
	                            isClosing: !0
	                        }), // Perform the actual closing at the end of the animation
	                        this.setTimeout(closeLightbox, this.props.animationDuration);
	                    }
	                }, {
	                    key: "requestMove",
	                    value: function(direction, event) {
	                        var _this15 = this, nextState = {
	                            zoomLevel: _constant.MIN_ZOOM_LEVEL,
	                            offsetX: 0,
	                            offsetY: 0
	                        };
	                        // Enable animated states
	                        this.props.animationDisabled || this.keyPressed && !this.props.animationOnKeyInput || (nextState.shouldAnimate = !0, 
	                        this.setTimeout(function() {
	                            return _this15.setState({
	                                shouldAnimate: !1
	                            });
	                        }, this.props.animationDuration)), this.keyPressed = !1, this.moveRequested = !0, 
	                        "prev" === direction ? (this.keyCounter -= 1, this.setState(nextState), this.props.onMovePrevRequest(event)) : (this.keyCounter += 1, 
	                        this.setState(nextState), this.props.onMoveNextRequest(event));
	                    }
	                }, {
	                    key: "requestMoveNext",
	                    value: function(event) {
	                        this.requestMove("next", event);
	                    }
	                }, {
	                    key: "requestMovePrev",
	                    value: function(event) {
	                        this.requestMove("prev", event);
	                    }
	                }, {
	                    key: "render",
	                    value: function() {
	                        var _this16 = this, _props = this.props, animationDisabled = _props.animationDisabled, animationDuration = _props.animationDuration, clickOutsideToClose = _props.clickOutsideToClose, discourageDownloads = _props.discourageDownloads, enableZoom = _props.enableZoom, imageTitle = _props.imageTitle, nextSrc = _props.nextSrc, prevSrc = _props.prevSrc, toolbarButtons = _props.toolbarButtons, reactModalStyle = _props.reactModalStyle, _onAfterOpen = _props.onAfterOpen, imageCrossOrigin = _props.imageCrossOrigin, reactModalProps = _props.reactModalProps, _state = this.state, zoomLevel = _state.zoomLevel, offsetX = _state.offsetX, offsetY = _state.offsetY, isClosing = _state.isClosing, loadErrorStatus = _state.loadErrorStatus, boxSize = this.getLightboxRect(), transitionStyle = {};
	                        // Transition settings for sliding animations
	                        !animationDisabled && this.isAnimating() && (transitionStyle = _extends({}, transitionStyle, {
	                            transition: "transform " + animationDuration + "ms"
	                        }));
	                        // Key endings to differentiate between images with the same src
	                        var keyEndings = {};
	                        this.getSrcTypes().forEach(function(_ref13) {
	                            var name = _ref13.name, keyEnding = _ref13.keyEnding;
	                            keyEndings[name] = keyEnding;
	                        });
	                        // Images to be displayed
	                        var images = [], addImage = function(srcType, imageClass, transforms) {
	                            // Ignore types that have no source defined for their full size image
	                            if (_this16.props[srcType]) {
	                                var bestImageInfo = _this16.getBestImageForType(srcType), imageStyle = _extends({}, transitionStyle, ReactImageLightbox.getTransform(_extends({}, transforms, bestImageInfo)));
	                                zoomLevel > _constant.MIN_ZOOM_LEVEL && (imageStyle.cursor = "move");
	                                // when error on one of the loads then push custom error stuff
	                                if (null === bestImageInfo && function(object) {
	                                    return Object.keys(object).some(function(key) {
	                                        return object[key];
	                                    });
	                                }(loadErrorStatus)) return void images.push(_react2.default.createElement("div", {
	                                    className: imageClass + " " + styles.image + " ril-errored",
	                                    style: imageStyle,
	                                    key: _this16.props[srcType] + keyEndings[srcType]
	                                }, _react2.default.createElement("div", {
	                                    className: styles.errorContainer
	                                }, _this16.props.imageLoadErrorMessage)));
	                                if (null === bestImageInfo) {
	                                    var loadingIcon = ieVersion < 10 ? _react2.default.createElement("div", {
	                                        className: styles.loadingContainer__icon
	                                    }, (0, _util.translate)("Loading...")) : _react2.default.createElement("div", {
	                                        className: "ril-loading-circle " + styles.loadingCircle + " " + styles.loadingContainer__icon
	                                    }, [].concat(_toConsumableArray(new Array(12))).map(function(_, index) {
	                                        return _react2.default.createElement("div", {
	                                            // eslint-disable-next-line react/no-array-index-key
	                                            key: index,
	                                            className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                        });
	                                    }));
	                                    // Fall back to loading icon if the thumbnail has not been loaded
	                                    return void images.push(_react2.default.createElement("div", {
	                                        className: imageClass + " " + styles.image + " ril-not-loaded",
	                                        style: imageStyle,
	                                        key: _this16.props[srcType] + keyEndings[srcType]
	                                    }, _react2.default.createElement("div", {
	                                        className: styles.loadingContainer
	                                    }, loadingIcon)));
	                                }
	                                var imageSrc = bestImageInfo.src;
	                                discourageDownloads ? (imageStyle.backgroundImage = "url('" + imageSrc + "')", images.push(_react2.default.createElement("div", {
	                                    className: imageClass + " " + styles.image + " " + styles.imageDiscourager,
	                                    onDoubleClick: _this16.handleImageDoubleClick,
	                                    onWheel: _this16.handleImageMouseWheel,
	                                    style: imageStyle,
	                                    key: imageSrc + keyEndings[srcType]
	                                }, _react2.default.createElement("div", {
	                                    className: "ril-download-blocker " + styles.downloadBlocker
	                                })))) : images.push(_react2.default.createElement("img", _extends({}, imageCrossOrigin ? {
	                                    crossOrigin: imageCrossOrigin
	                                } : {}, {
	                                    className: imageClass + " " + styles.image,
	                                    onDoubleClick: _this16.handleImageDoubleClick,
	                                    onWheel: _this16.handleImageMouseWheel,
	                                    onDragStart: function(e) {
	                                        return e.preventDefault();
	                                    },
	                                    style: imageStyle,
	                                    src: imageSrc,
	                                    key: imageSrc + keyEndings[srcType],
	                                    alt: "string" == typeof imageTitle ? imageTitle : (0, _util.translate)("Image"),
	                                    draggable: !1
	                                })));
	                            }
	                        }, zoomMultiplier = this.getZoomMultiplier();
	                        // Next Image (displayed on the right)
	                        addImage("nextSrc", "ril-image-next " + styles.imageNext, {
	                            x: boxSize.width
	                        }), // Main Image
	                        addImage("mainSrc", "ril-image-current", {
	                            x: -1 * offsetX,
	                            y: -1 * offsetY,
	                            zoom: zoomMultiplier
	                        }), // Previous Image (displayed on the left)
	                        addImage("prevSrc", "ril-image-prev " + styles.imagePrev, {
	                            x: -1 * boxSize.width
	                        });
	                        var modalStyle = {
	                            overlay: _extends({
	                                zIndex: 1e3,
	                                backgroundColor: "transparent"
	                            }, reactModalStyle.overlay),
	                            content: _extends({
	                                backgroundColor: "transparent",
	                                overflow: "hidden",
	                                // Needed, otherwise keyboard shortcuts scroll the page
	                                border: "none",
	                                borderRadius: 0,
	                                padding: 0,
	                                top: 0,
	                                left: 0,
	                                right: 0,
	                                bottom: 0
	                            }, reactModalStyle.content)
	                        };
	                        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
	                        return _react2.default.createElement(_reactModal2.default, _extends({
	                            isOpen: !0,
	                            onRequestClose: clickOutsideToClose ? this.requestClose : void 0,
	                            onAfterOpen: function() {
	                                // Focus on the div with key handlers
	                                _this16.outerEl && _this16.outerEl.focus(), _onAfterOpen();
	                            },
	                            style: modalStyle,
	                            contentLabel: (0, _util.translate)("Lightbox"),
	                            appElement: void 0 !== global.window ? global.window.document.body : void 0
	                        }, reactModalProps), _react2.default.createElement("div", {
	                            // eslint-disable-line jsx-a11y/no-static-element-interactions
	                            // Floating modal with closing animations
	                            className: "ril-outer " + styles.outer + " " + styles.outerAnimating + " " + this.props.wrapperClassName + " " + (isClosing ? "ril-closing " + styles.outerClosing : ""),
	                            style: {
	                                transition: "opacity " + animationDuration + "ms",
	                                animationDuration: animationDuration + "ms",
	                                animationDirection: isClosing ? "normal" : "reverse"
	                            },
	                            ref: function(el) {
	                                _this16.outerEl = el;
	                            },
	                            onWheel: this.handleOuterMousewheel,
	                            onMouseMove: this.handleMouseMove,
	                            onMouseDown: this.handleMouseDown,
	                            onTouchStart: this.handleTouchStart,
	                            onTouchMove: this.handleTouchMove,
	                            tabIndex: "-1",
	                            onKeyDown: this.handleKeyInput,
	                            onKeyUp: this.handleKeyInput
	                        }, _react2.default.createElement("div", {
	                            // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
	                            // Image holder
	                            className: "ril-inner " + styles.inner,
	                            onClick: clickOutsideToClose ? this.closeIfClickInner : void 0
	                        }, images), prevSrc && _react2.default.createElement("button", {
	                            // Move to previous image button
	                            type: "button",
	                            className: "ril-prev-button " + styles.navButtons + " " + styles.navButtonPrev,
	                            key: "prev",
	                            "aria-label": this.props.prevLabel,
	                            onClick: this.isAnimating() ? void 0 : this.requestMovePrev
	                        }), nextSrc && _react2.default.createElement("button", {
	                            // Move to next image button
	                            type: "button",
	                            className: "ril-next-button " + styles.navButtons + " " + styles.navButtonNext,
	                            key: "next",
	                            "aria-label": this.props.nextLabel,
	                            onClick: this.isAnimating() ? void 0 : this.requestMoveNext
	                        }), _react2.default.createElement("div", {
	                            // Lightbox toolbar
	                            className: "ril-toolbar " + styles.toolbar
	                        }, _react2.default.createElement("ul", {
	                            className: "ril-toolbar-left " + styles.toolbarSide + " " + styles.toolbarLeftSide
	                        }, _react2.default.createElement("li", {
	                            className: "ril-toolbar__item " + styles.toolbarItem
	                        }, _react2.default.createElement("span", {
	                            className: "ril-toolbar__item__child " + styles.toolbarItemChild
	                        }, imageTitle))), _react2.default.createElement("ul", {
	                            className: [ "ril-toolbar-right", styles.toolbarSide, styles.toolbarRightSide ].join(" ")
	                        }, toolbarButtons && toolbarButtons.map(function(button, i) {
	                            return _react2.default.createElement("li", {
	                                key: "button_" + (i + 1),
	                                className: "ril-toolbar__item " + styles.toolbarItem
	                            }, button);
	                        }), enableZoom && _react2.default.createElement("li", {
	                            className: "ril-toolbar__item " + styles.toolbarItem
	                        }, _react2.default.createElement("button", {
	                            // Lightbox zoom in button
	                            type: "button",
	                            key: "zoom-in",
	                            "aria-label": this.props.zoomInLabel,
	                            className: [ "ril-zoom-in", styles.toolbarItemChild, styles.builtinButton, styles.zoomInButton ].concat(_toConsumableArray(zoomLevel === _constant.MAX_ZOOM_LEVEL ? [ styles.builtinButtonDisabled ] : [])).join(" "),
	                            disabled: this.isAnimating() || zoomLevel === _constant.MAX_ZOOM_LEVEL,
	                            onClick: this.isAnimating() || zoomLevel === _constant.MAX_ZOOM_LEVEL ? void 0 : this.handleZoomInButtonClick
	                        })), enableZoom && _react2.default.createElement("li", {
	                            className: "ril-toolbar__item " + styles.toolbarItem
	                        }, _react2.default.createElement("button", {
	                            // Lightbox zoom out button
	                            type: "button",
	                            key: "zoom-out",
	                            "aria-label": this.props.zoomOutLabel,
	                            className: [ "ril-zoom-out", styles.toolbarItemChild, styles.builtinButton, styles.zoomOutButton ].concat(_toConsumableArray(zoomLevel === _constant.MIN_ZOOM_LEVEL ? [ styles.builtinButtonDisabled ] : [])).join(" "),
	                            disabled: this.isAnimating() || zoomLevel === _constant.MIN_ZOOM_LEVEL,
	                            onClick: this.isAnimating() || zoomLevel === _constant.MIN_ZOOM_LEVEL ? void 0 : this.handleZoomOutButtonClick
	                        })), _react2.default.createElement("li", {
	                            className: "ril-toolbar__item " + styles.toolbarItem
	                        }, _react2.default.createElement("button", {
	                            // Lightbox close button
	                            type: "button",
	                            key: "close",
	                            "aria-label": this.props.closeLabel,
	                            className: "ril-close ril-toolbar__item__child " + styles.toolbarItemChild + " " + styles.builtinButton + " " + styles.closeButton,
	                            onClick: this.isAnimating() ? void 0 : this.requestClose
	                        })))), this.props.imageCaption && _react2.default.createElement("div", {
	                            // Image caption
	                            onWheel: this.handleCaptionMousewheel,
	                            onMouseDown: function(event) {
	                                return event.stopPropagation();
	                            },
	                            className: "ril-caption " + styles.caption,
	                            ref: function(el) {
	                                _this16.caption = el;
	                            }
	                        }, _react2.default.createElement("div", {
	                            className: "ril-caption-content " + styles.captionContent
	                        }, this.props.imageCaption))));
	                    }
	                } ]), ReactImageLightbox;
	            }(_react.Component);
	            ReactImageLightbox.propTypes = {
	                //-----------------------------
	                // Image sources
	                //-----------------------------
	                // Main display image url
	                mainSrc: _propTypes2.default.string.isRequired,
	                // eslint-disable-line react/no-unused-prop-types
	                // Previous display image url (displayed to the left)
	                // If left undefined, movePrev actions will not be performed, and the button not displayed
	                prevSrc: _propTypes2.default.string,
	                // Next display image url (displayed to the right)
	                // If left undefined, moveNext actions will not be performed, and the button not displayed
	                nextSrc: _propTypes2.default.string,
	                //-----------------------------
	                // Image thumbnail sources
	                //-----------------------------
	                // Thumbnail image url corresponding to props.mainSrc
	                mainSrcThumbnail: _propTypes2.default.string,
	                // eslint-disable-line react/no-unused-prop-types
	                // Thumbnail image url corresponding to props.prevSrc
	                prevSrcThumbnail: _propTypes2.default.string,
	                // eslint-disable-line react/no-unused-prop-types
	                // Thumbnail image url corresponding to props.nextSrc
	                nextSrcThumbnail: _propTypes2.default.string,
	                // eslint-disable-line react/no-unused-prop-types
	                //-----------------------------
	                // Event Handlers
	                //-----------------------------
	                // Close window event
	                // Should change the parent state such that the lightbox is not rendered
	                onCloseRequest: _propTypes2.default.func.isRequired,
	                // Move to previous image event
	                // Should change the parent state such that props.prevSrc becomes props.mainSrc,
	                //  props.mainSrc becomes props.nextSrc, etc.
	                onMovePrevRequest: _propTypes2.default.func,
	                // Move to next image event
	                // Should change the parent state such that props.nextSrc becomes props.mainSrc,
	                //  props.mainSrc becomes props.prevSrc, etc.
	                onMoveNextRequest: _propTypes2.default.func,
	                // Called when an image fails to load
	                // (imageSrc: string, srcType: string, errorEvent: object): void
	                onImageLoadError: _propTypes2.default.func,
	                // Called when image successfully loads
	                onImageLoad: _propTypes2.default.func,
	                // Open window event
	                onAfterOpen: _propTypes2.default.func,
	                //-----------------------------
	                // Download discouragement settings
	                //-----------------------------
	                // Enable download discouragement (prevents [right-click -> Save Image As...])
	                discourageDownloads: _propTypes2.default.bool,
	                //-----------------------------
	                // Animation settings
	                //-----------------------------
	                // Disable all animation
	                animationDisabled: _propTypes2.default.bool,
	                // Disable animation on actions performed with keyboard shortcuts
	                animationOnKeyInput: _propTypes2.default.bool,
	                // Animation duration (ms)
	                animationDuration: _propTypes2.default.number,
	                //-----------------------------
	                // Keyboard shortcut settings
	                //-----------------------------
	                // Required interval of time (ms) between key actions
	                // (prevents excessively fast navigation of images)
	                keyRepeatLimit: _propTypes2.default.number,
	                // Amount of time (ms) restored after each keyup
	                // (makes rapid key presses slightly faster than holding down the key to navigate images)
	                keyRepeatKeyupBonus: _propTypes2.default.number,
	                //-----------------------------
	                // Image info
	                //-----------------------------
	                // Image title
	                imageTitle: _propTypes2.default.node,
	                // Image caption
	                imageCaption: _propTypes2.default.node,
	                // Optional crossOrigin attribute
	                imageCrossOrigin: _propTypes2.default.string,
	                //-----------------------------
	                // Lightbox style
	                //-----------------------------
	                // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
	                reactModalStyle: _propTypes2.default.shape({}),
	                // Padding (px) between the edge of the window and the lightbox
	                imagePadding: _propTypes2.default.number,
	                wrapperClassName: _propTypes2.default.string,
	                //-----------------------------
	                // Other
	                //-----------------------------
	                // Array of custom toolbar buttons
	                toolbarButtons: _propTypes2.default.arrayOf(_propTypes2.default.node),
	                // When true, clicks outside of the image close the lightbox
	                clickOutsideToClose: _propTypes2.default.bool,
	                // Set to false to disable zoom functionality and hide zoom buttons
	                enableZoom: _propTypes2.default.bool,
	                // Override props set on react-modal (https://github.com/reactjs/react-modal)
	                reactModalProps: _propTypes2.default.shape({}),
	                // Aria-labels
	                nextLabel: _propTypes2.default.string,
	                prevLabel: _propTypes2.default.string,
	                zoomInLabel: _propTypes2.default.string,
	                zoomOutLabel: _propTypes2.default.string,
	                closeLabel: _propTypes2.default.string,
	                imageLoadErrorMessage: _propTypes2.default.node
	            }, ReactImageLightbox.defaultProps = {
	                imageTitle: null,
	                imageCaption: null,
	                toolbarButtons: null,
	                reactModalProps: {},
	                animationDisabled: !1,
	                animationDuration: 300,
	                animationOnKeyInput: !1,
	                clickOutsideToClose: !0,
	                closeLabel: "Close lightbox",
	                discourageDownloads: !1,
	                enableZoom: !0,
	                imagePadding: 10,
	                imageCrossOrigin: null,
	                keyRepeatKeyupBonus: 40,
	                keyRepeatLimit: 180,
	                mainSrcThumbnail: null,
	                nextLabel: "Next image",
	                nextSrc: null,
	                nextSrcThumbnail: null,
	                onAfterOpen: function() {},
	                onImageLoadError: function() {},
	                onImageLoad: function() {},
	                onMoveNextRequest: function() {},
	                onMovePrevRequest: function() {},
	                prevLabel: "Previous image",
	                prevSrc: null,
	                prevSrcThumbnail: null,
	                reactModalStyle: {},
	                wrapperClassName: "",
	                zoomInLabel: "Zoom in",
	                zoomOutLabel: "Zoom out",
	                imageLoadErrorMessage: "This image failed to load"
	            }, exports.default = ReactImageLightbox;
	        }).call(exports, __webpack_require__(0));
	    }, /* 3 */
	    /***/
	    function(module, exports) {
	        module.exports = __webpack_require__(1);
	    }, /* 4 */
	    /***/
	    function(module, exports) {
	        module.exports = __webpack_require__(3);
	    }, /* 5 */
	    /***/
	    function(module, exports) {
	        module.exports = __webpack_require__(526);
	    }, /* 6 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        /* WEBPACK VAR INJECTION */
	        (function(global) {
	            /**
	 * Get the version of Internet Explorer in use, or undefined
	 *
	 * @return {?number} ieVersion - IE version as an integer, or undefined if not IE
	 */
	            function getIEVersion() {
	                if (void 0 !== global.window && void 0 !== global.window.navigator) {
	                    var match = global.window.navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
	                    return match ? parseInt(match[1], 10) : void 0;
	                }
	            }
	            /**
	 * Placeholder for future translate functionality
	 */
	            function translate(str) {
	                var replaceStrings = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
	                if (!str) return "";
	                var translated = str;
	                return replaceStrings && Object.keys(replaceStrings).forEach(function(placeholder) {
	                    translated = translated.replace(placeholder, replaceStrings[placeholder]);
	                }), translated;
	            }
	            function getWindowWidth() {
	                return void 0 !== global.window ? global.window.innerWidth : 0;
	            }
	            function getWindowHeight() {
	                return void 0 !== global.window ? global.window.innerHeight : 0;
	            }
	            // Get the highest window context that isn't cross-origin
	            // (When in an iframe)
	            function getHighestSafeWindowContext() {
	                var self = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : global.window.self;
	                // If we reached the top level, return self
	                if (self === global.window.top) return self;
	                var getOrigin = function(href) {
	                    return href.match(/(.*\/\/.*?)(\/|$)/)[1];
	                };
	                // If parent is the same origin, we can move up one context
	                // Reference: https://stackoverflow.com/a/21965342/1601953
	                // If parent is the same origin, we can move up one context
	                // Reference: https://stackoverflow.com/a/21965342/1601953
	                return getOrigin(self.location.href) === getOrigin(self.document.referrer) ? getHighestSafeWindowContext(self.parent) : self;
	            }
	            Object.defineProperty(exports, "__esModule", {
	                value: !0
	            }), exports.getIEVersion = getIEVersion, exports.translate = translate, exports.getWindowWidth = getWindowWidth, 
	            exports.getWindowHeight = getWindowHeight, exports.getHighestSafeWindowContext = getHighestSafeWindowContext;
	        }).call(exports, __webpack_require__(0));
	    }, /* 7 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        });
	        // Min image zoom level
	        exports.MIN_ZOOM_LEVEL = 0, exports.MAX_ZOOM_LEVEL = 300, exports.ZOOM_RATIO = 1.007, 
	        exports.ZOOM_BUTTON_INCREMENT_SIZE = 100, exports.WHEEL_MOVE_X_THRESHOLD = 200, 
	        exports.WHEEL_MOVE_Y_THRESHOLD = 1, exports.KEYS = {
	            ESC: 27,
	            LEFT_ARROW: 37,
	            RIGHT_ARROW: 39
	        }, exports.ACTION_NONE = 0, exports.ACTION_MOVE = 1, exports.ACTION_SWIPE = 2, exports.ACTION_PINCH = 3, 
	        exports.ACTION_ROTATE = 4, exports.SOURCE_ANY = 0, exports.SOURCE_MOUSE = 1, exports.SOURCE_TOUCH = 2, 
	        exports.SOURCE_POINTER = 3, exports.MIN_SWIPE_DISTANCE = 200;
	    }, /* 8 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        var content = __webpack_require__(9), insertCss = __webpack_require__(11);
	        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), module.exports = content.locals || {}, 
	        module.exports._getContent = function() {
	            return content;
	        }, module.exports._getCss = function() {
	            return content.toString();
	        }, module.exports._insertCss = function(options) {
	            return insertCss(content, options);
	        };
	    }, /* 9 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        exports = module.exports = __webpack_require__(10)(!1), // imports
	        // module
	        exports.push([ module.i, '@-webkit-keyframes ril__closeWindow {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ril__closeWindow {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.ril__outer {\n  background-color: rgba(0, 0, 0, 0.85);\n  outline: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  -ms-content-zooming: none;\n  -ms-user-select: none;\n  -ms-touch-select: none;\n  -ms-touch-action: none;\n      touch-action: none; }\n\n.ril__outerClosing {\n  opacity: 0; }\n\n.ril__inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.ril__image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  max-width: none;\n  -ms-content-zooming: none;\n  -ms-user-select: none;\n  -ms-touch-select: none;\n  -ms-touch-action: none;\n      touch-action: none; }\n\n.ril__imagePrev {\n  @extends .image; }\n\n.ril__imageNext {\n  @extends .image; }\n\n.ril__imageDiscourager {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain; }\n\n.ril__navButtons {\n  border: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  height: 34px;\n  padding: 40px 30px;\n  margin: auto;\n  cursor: pointer;\n  opacity: 0.7; }\n  .ril__navButtons:hover {\n    opacity: 1; }\n  .ril__navButtons:active {\n    opacity: 0.7; }\n\n.ril__navButtonPrev {\n  left: 0;\n  background: rgba(0, 0, 0, 0.2) url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==") no-repeat center; }\n\n.ril__navButtonNext {\n  right: 0;\n  background: rgba(0, 0, 0, 0.2) url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+") no-repeat center; }\n\n.ril__downloadBlocker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");\n  background-size: cover; }\n\n.ril__caption,\n.ril__toolbar {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  left: 0;\n  right: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n.ril__caption {\n  bottom: 0;\n  max-height: 150px;\n  overflow: auto; }\n\n.ril__captionContent {\n  padding: 10px 20px;\n  color: #fff; }\n\n.ril__toolbar {\n  top: 0;\n  height: 50px; }\n\n.ril__toolbarSide {\n  height: 50px;\n  margin: 0; }\n\n.ril__toolbarSideNoFlex {\n  height: auto;\n  line-height: 50px;\n  max-width: 48%;\n  position: absolute;\n  top: 0;\n  bottom: 0; }\n\n.ril__toolbarLeftSide {\n  padding-left: 20px;\n  padding-right: 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.ril__toolbarLeftSideNoFlex {\n  left: 0;\n  overflow: visible; }\n\n.ril__toolbarRightSide {\n  padding-left: 0;\n  padding-right: 20px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto; }\n\n.ril__toolbarRightSideNoFlex {\n  right: 0; }\n\n.ril__toolbarItem {\n  display: inline-block;\n  line-height: 50px;\n  padding: 0;\n  color: #fff;\n  font-size: 120%;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.ril__toolbarItemChild {\n  vertical-align: middle; }\n\n.ril__builtinButton {\n  width: 40px;\n  height: 35px;\n  cursor: pointer;\n  border: none;\n  opacity: 0.7; }\n  .ril__builtinButton:hover {\n    opacity: 1; }\n  .ril__builtinButton:active {\n    outline: none; }\n\n.ril__builtinButtonDisabled {\n  cursor: default;\n  opacity: 0.5; }\n  .ril__builtinButtonDisabled:hover {\n    opacity: 0.5; }\n\n.ril__closeButton {\n  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=") no-repeat center; }\n\n.ril__zoomInButton {\n  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+") no-repeat center; }\n\n.ril__zoomOutButton {\n  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=") no-repeat center; }\n\n.ril__outerAnimating {\n  -webkit-animation-name: ril__closeWindow;\n          animation-name: ril__closeWindow; }\n\n@-webkit-keyframes ril__pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0; }\n  20% {\n    opacity: 1; } }\n\n@keyframes ril__pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0; }\n  20% {\n    opacity: 1; } }\n\n.ril__loadingCircle {\n  width: 60px;\n  height: 60px;\n  position: relative; }\n\n.ril__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0; }\n  .ril__loadingCirclePoint:before {\n    content: \'\';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: #fff;\n    border-radius: 30%;\n    -webkit-animation: ril__pointFade 1200ms infinite ease-in-out both;\n            animation: ril__pointFade 1200ms infinite ease-in-out both; }\n  .ril__loadingCirclePoint:nth-of-type(1) {\n    -webkit-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  .ril__loadingCirclePoint:nth-of-type(7) {\n    -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  .ril__loadingCirclePoint:nth-of-type(1):before, .ril__loadingCirclePoint:nth-of-type(7):before {\n    -webkit-animation-delay: -1200ms;\n            animation-delay: -1200ms; }\n  .ril__loadingCirclePoint:nth-of-type(2) {\n    -webkit-transform: rotate(30deg);\n        -ms-transform: rotate(30deg);\n            transform: rotate(30deg); }\n  .ril__loadingCirclePoint:nth-of-type(8) {\n    -webkit-transform: rotate(210deg);\n        -ms-transform: rotate(210deg);\n            transform: rotate(210deg); }\n  .ril__loadingCirclePoint:nth-of-type(2):before, .ril__loadingCirclePoint:nth-of-type(8):before {\n    -webkit-animation-delay: -1000ms;\n            animation-delay: -1000ms; }\n  .ril__loadingCirclePoint:nth-of-type(3) {\n    -webkit-transform: rotate(60deg);\n        -ms-transform: rotate(60deg);\n            transform: rotate(60deg); }\n  .ril__loadingCirclePoint:nth-of-type(9) {\n    -webkit-transform: rotate(240deg);\n        -ms-transform: rotate(240deg);\n            transform: rotate(240deg); }\n  .ril__loadingCirclePoint:nth-of-type(3):before, .ril__loadingCirclePoint:nth-of-type(9):before {\n    -webkit-animation-delay: -800ms;\n            animation-delay: -800ms; }\n  .ril__loadingCirclePoint:nth-of-type(4) {\n    -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n            transform: rotate(90deg); }\n  .ril__loadingCirclePoint:nth-of-type(10) {\n    -webkit-transform: rotate(270deg);\n        -ms-transform: rotate(270deg);\n            transform: rotate(270deg); }\n  .ril__loadingCirclePoint:nth-of-type(4):before, .ril__loadingCirclePoint:nth-of-type(10):before {\n    -webkit-animation-delay: -600ms;\n            animation-delay: -600ms; }\n  .ril__loadingCirclePoint:nth-of-type(5) {\n    -webkit-transform: rotate(120deg);\n        -ms-transform: rotate(120deg);\n            transform: rotate(120deg); }\n  .ril__loadingCirclePoint:nth-of-type(11) {\n    -webkit-transform: rotate(300deg);\n        -ms-transform: rotate(300deg);\n            transform: rotate(300deg); }\n  .ril__loadingCirclePoint:nth-of-type(5):before, .ril__loadingCirclePoint:nth-of-type(11):before {\n    -webkit-animation-delay: -400ms;\n            animation-delay: -400ms; }\n  .ril__loadingCirclePoint:nth-of-type(6) {\n    -webkit-transform: rotate(150deg);\n        -ms-transform: rotate(150deg);\n            transform: rotate(150deg); }\n  .ril__loadingCirclePoint:nth-of-type(12) {\n    -webkit-transform: rotate(330deg);\n        -ms-transform: rotate(330deg);\n            transform: rotate(330deg); }\n  .ril__loadingCirclePoint:nth-of-type(6):before, .ril__loadingCirclePoint:nth-of-type(12):before {\n    -webkit-animation-delay: -200ms;\n            animation-delay: -200ms; }\n  .ril__loadingCirclePoint:nth-of-type(7) {\n    -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  .ril__loadingCirclePoint:nth-of-type(13) {\n    -webkit-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n            transform: rotate(360deg); }\n  .ril__loadingCirclePoint:nth-of-type(7):before, .ril__loadingCirclePoint:nth-of-type(13):before {\n    -webkit-animation-delay: 0ms;\n            animation-delay: 0ms; }\n\n.ril__loadingContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n  .ril__imagePrev .ril__loadingContainer {\n    display: none; }\n  .ril__imageNext .ril__loadingContainer {\n    display: none; }\n\n.ril__errorContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: #fff; }\n  .ril__imagePrev .ril__errorContainer {\n    display: none; }\n  .ril__imageNext .ril__errorContainer {\n    display: none; }\n\n.ril__loadingContainer__icon {\n  color: #fff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n      -ms-transform: translateX(-50%) translateY(-50%);\n          transform: translateX(-50%) translateY(-50%); }\n', "" ]), 
	        // exports
	        exports.locals = {
	            outer: "ril__outer",
	            outerClosing: "ril__outerClosing",
	            inner: "ril__inner",
	            image: "ril__image",
	            imagePrev: "ril__imagePrev",
	            imageNext: "ril__imageNext",
	            imageDiscourager: "ril__imageDiscourager",
	            navButtons: "ril__navButtons",
	            navButtonPrev: "ril__navButtonPrev",
	            navButtonNext: "ril__navButtonNext",
	            downloadBlocker: "ril__downloadBlocker",
	            caption: "ril__caption",
	            toolbar: "ril__toolbar",
	            captionContent: "ril__captionContent",
	            toolbarSide: "ril__toolbarSide",
	            toolbarSideNoFlex: "ril__toolbarSideNoFlex",
	            toolbarLeftSide: "ril__toolbarLeftSide",
	            toolbarLeftSideNoFlex: "ril__toolbarLeftSideNoFlex",
	            toolbarRightSide: "ril__toolbarRightSide",
	            toolbarRightSideNoFlex: "ril__toolbarRightSideNoFlex",
	            toolbarItem: "ril__toolbarItem",
	            toolbarItemChild: "ril__toolbarItemChild",
	            builtinButton: "ril__builtinButton",
	            builtinButtonDisabled: "ril__builtinButtonDisabled",
	            closeButton: "ril__closeButton",
	            zoomInButton: "ril__zoomInButton",
	            zoomOutButton: "ril__zoomOutButton",
	            outerAnimating: "ril__outerAnimating",
	            closeWindow: "ril__closeWindow",
	            loadingCircle: "ril__loadingCircle",
	            loadingCirclePoint: "ril__loadingCirclePoint",
	            pointFade: "ril__pointFade",
	            loadingContainer: "ril__loadingContainer",
	            errorContainer: "ril__errorContainer",
	            loadingContainer__icon: "ril__loadingContainer__icon"
	        };
	    }, /* 10 */
	    /***/
	    function(module, exports) {
	        function cssWithMappingToString(item, useSourceMap) {
	            var content = item[1] || "", cssMapping = item[3];
	            if (!cssMapping) return content;
	            if (useSourceMap && "function" == typeof btoa) {
	                var sourceMapping = toComment(cssMapping);
	                return [ content ].concat(cssMapping.sources.map(function(source) {
	                    return "/*# sourceURL=" + cssMapping.sourceRoot + source + " */";
	                })).concat([ sourceMapping ]).join("\n");
	            }
	            return [ content ].join("\n");
	        }
	        // Adapted from convert-source-map (MIT)
	        function toComment(sourceMap) {
	            return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	        }
	        /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	        // css base code, injected by the css-loader
	        module.exports = function(useSourceMap) {
	            var list = [];
	            // return the list of modules as css string
	            // import a list of modules into the list
	            return list.toString = function() {
	                return this.map(function(item) {
	                    var content = cssWithMappingToString(item, useSourceMap);
	                    return item[2] ? "@media " + item[2] + "{" + content + "}" : content;
	                }).join("");
	            }, list.i = function(modules, mediaQuery) {
	                "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
	                for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
	                    var id = this[i][0];
	                    "number" == typeof id && (alreadyImportedModules[id] = !0);
	                }
	                for (i = 0; i < modules.length; i++) {
	                    var item = modules[i];
	                    // skip already imported module
	                    // this implementation is not 100% perfect for weird media query combinations
	                    //  when a module is imported multiple times with different media queries.
	                    //  I hope this will never occur (Hey this way we have smaller bundles)
	                    "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
	                    list.push(item));
	                }
	            }, list;
	        };
	    }, /* 11 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        // Base64 encoding and decoding - The "Unicode Problem"
	        // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
	        function b64EncodeUnicode(str) {
	            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
	                return String.fromCharCode("0x" + p1);
	            }));
	        }
	        /**
	 * Remove style/link elements for specified node IDs
	 * if they are no longer referenced by UI components.
	 */
	        function removeCss(ids) {
	            ids.forEach(function(id) {
	                if (--inserted[id] <= 0) {
	                    var elem = document.getElementById(prefix + id);
	                    elem && elem.parentNode.removeChild(elem);
	                }
	            });
	        }
	        /**
	 * Example:
	 *   // Insert CSS styles object generated by `css-loader` into DOM
	 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
	 *
	 *   // Remove it from the DOM
	 *   removeCss();
	 */
	        function insertCss(styles) {
	            for (var _ref = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _ref$replace = _ref.replace, replace = void 0 !== _ref$replace && _ref$replace, _ref$prepend = _ref.prepend, prepend = void 0 !== _ref$prepend && _ref$prepend, ids = [], i = 0; i < styles.length; i++) {
	                var _styles$i = (0, _slicedToArray3.default)(styles[i], 4), moduleId = _styles$i[0], css = _styles$i[1], media = _styles$i[2], sourceMap = _styles$i[3], id = moduleId + "-" + i;
	                if (ids.push(id), !inserted[id] || replace) {
	                    inserted[id] = 1;
	                    var elem = document.getElementById(prefix + id), create = !1;
	                    elem || (create = !0, elem = document.createElement("style"), elem.setAttribute("type", "text/css"), 
	                    elem.id = prefix + id, media && elem.setAttribute("media", media));
	                    var cssText = css;
	                    sourceMap && "function" == typeof btoa && (// skip IE9 and below, see http://caniuse.com/atob-btoa
	                    cssText += "\n/*# sourceMappingURL=data:application/json;base64," + b64EncodeUnicode((0, 
	                    _stringify2.default)(sourceMap)) + "*/", cssText += "\n/*# sourceURL=" + sourceMap.file + "?" + id + "*/"), 
	                    "textContent" in elem ? elem.textContent = cssText : elem.styleSheet.cssText = cssText, 
	                    create && (prepend ? document.head.insertBefore(elem, document.head.childNodes[0]) : document.head.appendChild(elem));
	                } else inserted[id]++;
	            }
	            return removeCss.bind(null, ids);
	        }
	        var _stringify = __webpack_require__(12), _stringify2 = _interopRequireDefault(_stringify), _slicedToArray2 = __webpack_require__(13), _slicedToArray3 = _interopRequireDefault(_slicedToArray2), prefix = "s", inserted = {};
	        module.exports = insertCss;
	    }, /* 12 */
	    /***/
	    function(module, exports) {
	        module.exports = __webpack_require__(147);
	    }, /* 13 */
	    /***/
	    function(module, exports) {
	        module.exports = __webpack_require__(269);
	    } ]);
	});

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(14);
	var DOMFactories = __webpack_require__(217);
	var PropTypes = __webpack_require__(3);
	var ExecutionEnvironment = __webpack_require__(122);
	var ModalPortal = React.createFactory(__webpack_require__(521));
	var ariaAppHider = __webpack_require__(522);
	var refCount = __webpack_require__(524);
	var elementClass = __webpack_require__(372);
	var renderSubtreeIntoContainer = __webpack_require__(14).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(193);
	var createReactClass = __webpack_require__(178);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = createReactClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: PropTypes.bool.isRequired,
	    style: PropTypes.shape({
	      content: PropTypes.object,
	      overlay: PropTypes.object
	    }),
	    portalClassName: PropTypes.string,
	    bodyOpenClassName: PropTypes.string,
	    appElement: PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: PropTypes.func,
	    onRequestClose: PropTypes.func,
	    closeTimeoutMS: PropTypes.number,
	    ariaHideApp: PropTypes.bool,
	    shouldCloseOnOverlayClick: PropTypes.bool,
	    parentSelector: PropTypes.func,
	    role: PropTypes.string,
	    contentLabel: PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      bodyOpenClassName: 'ReactModal__Body--open',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true,
	      parentSelector: function () { return document.body; }
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	
	    if (this.props.isOpen) refCount.add(this);
	
	    var parent = getParentElement(this.props.parentSelector);
	    parent.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillUpdate: function(newProps) {
	    if(newProps.portalClassName !== this.props.portalClassName) {
	      this.node.className = newProps.portalClassName;
	    }
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    if (newProps.isOpen) refCount.add(this);
	    if (!newProps.isOpen) refCount.remove(this);
	    var currentParent = getParentElement(this.props.parentSelector);
	    var newParent = getParentElement(newProps.parentSelector);
	
	    if(newParent !== currentParent) {
	      currentParent.removeChild(this.node);
	      newParent.appendChild(this.node);
	    }
	
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    if (!this.node) return;
	
	    refCount.remove(this);
	
	    if (this.props.ariaHideApp) {
	      ariaAppHider.show(this.props.appElement);
	    }
	
	    var state = this.portal.state;
	    var now = Date.now();
	    var closesAt = state.isOpen && this.props.closeTimeoutMS
	      && (state.closesAt
	        || now + this.props.closeTimeoutMS);
	
	    if (closesAt) {
	      if (!state.beforeClose) {
	        this.portal.closeWithTimeout();
	      }
	
	      var that = this;
	      setTimeout(function() { that.removePortal(); }, closesAt - now);
	    } else {
	      this.removePortal();
	    }
	  },
	
	  removePortal: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    var parent = getParentElement(this.props.parentSelector);
	    parent.removeChild(this.node);
	
	    if (refCount.count() === 0) {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen || refCount.count() > 0) {
	      elementClass(document.body).add(this.props.bodyOpenClassName);
	    } else {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return DOMFactories.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var DOMFactories = __webpack_require__(217);
	var focusManager = __webpack_require__(523);
	var scopeTab = __webpack_require__(525);
	var Assign = __webpack_require__(193);
	var createReactClass = __webpack_require__(178);
	
	var div = DOMFactories.div;
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: 'ReactModal__Overlay',
	  content: 'ReactModal__Content'
	};
	
	var ModalPortal = module.exports = createReactClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  afterClose: function () {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  open: function () {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    var closesAt = Date.now() + this.props.closeTimeoutMS;
	    this.setState({beforeClose: true, closesAt: closesAt}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	      closesAt: null
	    }, this.afterClose);
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayOnClick: function (event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentOnClick: function () {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.state.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var classNames = (typeof additional === 'object') ? additional : {
	      base: CLASS_NAMES[which],
	      afterOpen: CLASS_NAMES[which] + "--after-open",
	      beforeClose: CLASS_NAMES[which] + "--before-close"
	    };
	    var className = classNames.base;
	    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
	    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
	    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayOnClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onClick: this.handleContentOnClick,
	          role: this.props.role,
	          "aria-label": this.props.contentLabel
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(219);
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElements.push(document.activeElement);
	};
	
	exports.returnFocus = function() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
	  }
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};


/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	var modals = [];
	
	module.exports = {
	  add: function (element) {
	    if (modals.indexOf(element) === -1) {
	      modals.push(element);
	    }
	  },
	  remove: function (element) {
	    var index = modals.indexOf(element);
	    if (index === -1) {
	      return;
	    }
	    modals.splice(index, 1);
	  },
	  count: function () {
	    return modals.length;
	  }
	};


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(219);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ }),

/***/ 219:
/***/ (function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(520);
	


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(125);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_React$Component) {
	  _inherits(Project, _React$Component);
	
	  function Project(props) {
	    _classCallCheck(this, Project);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  Project.prototype.render = function render() {
	    var _this2 = this;
	
	    var project = this.props.data;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: "project__col" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "project__overlay_container",
	          style: {
	            opacity: this.state.isOpen ? 1 : 0,
	            pointerEvents: this.state.isOpen ? "auto" : "none"
	          },
	          onClick: function onClick() {
	            return _this2.setState({ isOpen: false });
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "project__overlay_content_wrapper",
	            onClick: function onClick(ev) {
	              return ev.stopPropagation();
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            {
	              className: "project__overlay_close_btn",
	              onClick: function onClick() {
	                return _this2.setState({ isOpen: false });
	              }
	            },
	            "\u2715"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "project__overlay_fluid_img" },
	            _react2.default.createElement(_gatsbyImage2.default, {
	              sizes: project.fullImage,
	              style: { position: "static" }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "project__overlay_content" },
	            _react2.default.createElement(
	              "h2",
	              { className: "subtitle" },
	              project.name,
	              " (",
	              project.year,
	              ")"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              project.ask
	            ),
	            project.recommendations ? _react2.default.createElement(
	              "div",
	              { className: "project__sub_container" },
	              _react2.default.createElement(
	                "h3",
	                { className: "subtitle" },
	                "Recommendations"
	              ),
	              project.recommendations.map(function (rec) {
	                return _react2.default.createElement(
	                  "div",
	                  { className: "project__recs_block" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "\u201C",
	                    rec.quote,
	                    "\u201D"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "project__recs_author" },
	                    "\u2014 ",
	                    rec.author
	                  )
	                );
	              })
	            ) : null,
	            project.awards ? _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(
	                "h3",
	                { className: "subtitle" },
	                "Awards"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "project__awards_block" },
	                project.awards.map(function (award) {
	                  return _react2.default.createElement(
	                    "li",
	                    null,
	                    award
	                  );
	                })
	              )
	            ) : null
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, {
	          resolutions: project.thumbnail,
	          style: { borderRadius: "100%" }
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "project__btn" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "button button--primary",
	            onClick: function onClick() {
	              return _this2.setState({ isOpen: true });
	            }
	          },
	          project.name
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react2.default.Component);
	
	exports.default = Project;
	module.exports = exports["default"];

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImageLightbox = __webpack_require__(516);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	var _Project = __webpack_require__(250);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	__webpack_require__(74);
	
	__webpack_require__(376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientsPage = function (_Component) {
	  _inherits(ClientsPage, _Component);
	
	  function ClientsPage() {
	    _classCallCheck(this, ClientsPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ClientsPage.prototype.render = function render() {
	    var _props$data = this.props.data,
	        _props$data$markdownR = _props$data.markdownRemark.frontmatter,
	        projects = _props$data$markdownR.projects,
	        nsac = _props$data$markdownR.nsac,
	        images = _props$data.allFile.edges;
	
	
	    var keyByOriginalNameFrom = function keyByOriginalNameFrom(key) {
	      return function (obj, img) {
	        var res = img.node.childImageSharp[key];
	        obj[res.originalName] = res;
	        return obj;
	      };
	    };
	
	    var thumbnailMap = images.reduce(keyByOriginalNameFrom("thumbnail"), {});
	    var imageMap = images.reduce(keyByOriginalNameFrom("full"), {});
	    var getImgFromMap = function getImgFromMap(map, img) {
	      return map[img.split('/').pop()];
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'imgContainer' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'title' },
	        'CLIENTS'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'subtitle subtitle--lowercase' },
	        'Fall Consulting Projects'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project__container' },
	        projects.map(function (project) {
	          project.thumbnail = getImgFromMap(thumbnailMap, project.image);
	          project.fullImage = getImgFromMap(imageMap, project.image);
	          return _react2.default.createElement(_Project2.default, { data: project });
	        })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'subtitle subtitle--lowercase' },
	        'National Student Advertising Competition'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project__container' },
	        nsac.map(function (project) {
	          project.thumbnail = getImgFromMap(thumbnailMap, project.image);
	          project.fullImage = getImgFromMap(imageMap, project.image);
	          return _react2.default.createElement(_Project2.default, { data: project });
	        })
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: 'title' },
	        'SPONSORS'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'body__text_container' },
	        _react2.default.createElement(
	          'p',
	          { className: 'body__text' },
	          'Everything you see from imagiCal is a result of our perseverance and willingness to spend the time and effort to maximize our wealth and produce the best campaign that we can. While other NSAC teams may have a class or resources dedicated to the competition, imagiCal is 100% student-run and relies completely on donor support to fund our presentation materials and campaign needs. We have a proven track record of attracting the best and brightest to our organization, and as you can see from our accomplishments to the left, we take pride in creating nationally recognized work. Please refer to our sponsorship packet [link] to understand what we can provide for you and contact us at\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:contact@calaaf.com', className: 'body__link' },
	            'contact@calaaf.com'
	          ),
	          '\xA0if you are interested in learning more. We are also very willing to accomodate custom sponsorship packages.'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: '' },
	          'Be Our Sponsor'
	        )
	      )
	    );
	  };
	
	  return ClientsPage;
	}(_react.Component);
	
	exports.default = ClientsPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-clients-js-ede2494738b24c24cac3.js